import Service from "../../AuthService";
const AdvancePaymentDetails = {
    getAdvancePaymentDetails(page) {
        return Service.get("/advance_payment_details?page="+page);
    },
    showAdvancePaymentDetails(id,page) {
        return Service.get("/advance_payment_details/" + id+ "?page="+page);
    },
    updateAdvancePaymentDetails(id, data) {
        return Service.put("/advance_payment_details/" + id, data);
    },
    createAdvancePaymentDetails(data) {
        return Service.post("/advance_payment_details", data);
    },
    deleteAdvancePaymentDetails(id) {
        return Service.delete("/advance_payment_details/" + id);
    },
};
export default AdvancePaymentDetails;
